import { render, staticRenderFns } from "./FreemiumFilterBadge.vue?vue&type=template&id=31ad6c08"
import script from "./FreemiumFilterBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./FreemiumFilterBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FreemiumFilterBadge.vue?vue&type=style&index=0&id=31ad6c08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports